import styled from 'styled-components';
import {
  pb, px, mt, pl, py, m, mx, p, pr, pt, my
} from 'styled-components-spacing';
import breakpoint from 'styled-components-breakpoint';
import theme from '@lib/theme';
import Grid from 'styled-components-grid';
import { colors } from '@components/ListItemFacility/styles';

export const StyledMainCover = styled.div`
  ${p(2)};
`;

export const StyledGridWrapper = styled(Grid)`
  ${breakpoint('desktop')`
  ${p(2)};
  `};
  ${breakpoint('mobile', 'tablet')`
  ${p(0)};
  `};
`;

export const StyledMainGridWrapper = styled(Grid)`
  ${breakpoint('mobile', 'desktop')`
  display:flex;
  width:100%;
  flex-direction: column-reverse;
  `};
`;
export const StyledGridUnit = styled(Grid.Unit)``;

export const StyledTopSectionWrapper = styled(Grid)``;

export const StyledTopImageGridWapper = styled(Grid.Unit)`
  img {
    width: 100%;
    height: 100%;
    ${m(2)};
    border-radius: 8px;
  }
`;
export const StyledTopImageWrapper = styled.div`
  ${p(3)};
  img {
    width: 100%;
  }
`;

export const StyledTopImagesCarousel = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const StyledTopCarouselImage = styled.div`
  ${p(2)};
  img {
    border: 1px solid transparent;
    border-radius: 4px;
    height: 100%;
    max-width: 100px;
    width: 100%;
  }
`;

export const StyledTopTextGridWapper = styled(Grid.Unit)`
  ${p(3)};
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  ${breakpoint('mobile', 'tablet')`
     ${p(1)};
  `};
`;

export const StyledTitleMain = styled.h1`
  color: ${theme.colors.darkGray};
  font-size: 38px;
  font-weight: bold;
  ${breakpoint('mobile', 'tablet')`
    font-size: 28px;
    line-height: 2rem;
    ${py(2)};
  `};
`;

export const StyledTitleSecond = styled.h2`
  color: ${theme.colors.darkGray};
  font-size: 38px;
  font-weight: bold;
  line-height: 1.4;
  ${breakpoint('mobile', 'tablet')`
    font-size: 28px;
    line-height: 2rem;
    ${py(2)};
  `};
`;

export const StyledLocationWrapper = styled.div`
  ${py(2)};
  display: flex;
  flex-direction: row;
  line-spacing: 1.2rem;
  margin-top: 1rem;
  ${breakpoint('mobile', 'desktop')`
    ${py(2)};

  `};
  ${breakpoint('desktop')`
    margin-bottom: 30px;
  `}
`;

export const StyledLocationIconWrapper = styled.div`
  ${pr(1)};

  svg {
    height: 25px;
    width: 25px;
  }
`;

export const StyledLocationText = styled.h3`
  color: ${theme.colors.navyGray};
  font-size: 18px;
  font-weight: 600;
`;

export const StyledFacilityCardsWrapperDesktopVisible = styled(Grid)`
  ${breakpoint('desktop')`
  display: flex;
    row-gap: 20px;
  `}
`;

export const StyledDesktopVisible = styled(Grid)`
  display: none;
  ${breakpoint('desktop')`
    display: block;
  `}
`;

export const StyledMobileVisible = styled(Grid)`
  display: block;
  ${breakpoint('desktop')`
  display: none;
 `}
`;

export const StyledPriceHeadline = styled.h3`
  font-weight: 700;
  text-align: left;
  font-size: 24px;

  ${breakpoint('tablet', 'desktop')`
   font-size: 26px;
  `}

  ${breakpoint('desktop')`
      font-size: 36px;
      font-weight: 800;
      color: ${colors.navyGray};
      padding: 0px;
  `}
`;

export const StyledCardItemsWrapper = styled.div`
  height: 100%;
  width: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const StyledFacilityCards = styled(Grid.Unit)`
/* display: flex;
justify-content: ${({ justify }) => justify || 'center'}; */
/* display: flex;
flex-direction: column;
align-items: flex-start; */
  /* ${p(2)};
  ${m(2)};
  height: 50px;
  width: 100%;
  border: 1px solid transparent;
  border-radius: 4px;
  box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: row;
  flex: 1;
  justify-content: space-evenly;
  @media only screen and (min-width: 1020px) and (max-width: 1250px) {
    height: 60px;
  }
  ${breakpoint('mobile', 'tablet')`
  ${p(1)};
  ${my(1)};
  ${mx(0)};
  height: 100%;
    svg{
        width:80%;
        max-width:5vh;
        min-width:10px;
        min-height: 6px;
        height: 80%;    }
  `}; */


  ${breakpoint('mobile', 'desktop')`
    display: flex;
    justify-content: center;

    svg{
height: 60px;
padding: 10px 0px;
    }

    img{
height: 60px;
padding: 10px 0px;
    }
  `}

${breakpoint('desktop')`
    svg{
      height: 60px;
       padding: 5px 0px;
    }

    img{
      height: 60px;
    padding: 5px 0px;
    }
    `}
  
`;

export const StyledFacilityCardsTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  max-width: 100%;
  align-items: center;
  justify-content: center;
  ${pl(1)};
  ${breakpoint('mobile', 'tablet')`
    font-size:12px;
    line-height:1.2rem;
    ${py(0)};
  `};
`;

export const StyledFacilityCardsTitle = styled.div`
  color: ${theme.colors.black};
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  display: flex;
  flex-wrap: wrap;
  padding: 5px 0px;
  ${breakpoint('mobile', 'tablet')`
    font-size:14px;
    line-height:1rem;
    ${py(0)};
  `};
`;

export const StyledFacilityCardsSubtitle = styled.div`
  color: ${({ color }) => color || 'black'};
  font-weight: 800;
  padding: 5px 0px;
  ${breakpoint('mobile', 'tablet')`
  font-size:14px;
`};
`;

export const StyledPriceWrapper = styled.div`
  display: flex;
  flex-direction: row;
  ${p(2)};
  align-items: center;
  justify-content: space-between;
  border-top: 2px solid ${colors.navyGray};
  border-bottom: 2px solid ${colors.navyGray};
  ${breakpoint('mobile', 'desktop')`
   ${py(3)};
   margin: 1rem 0;
`}
  ${breakpoint('desktop')`
  margin: 30px 0px;
  padding-right: 30px;
  padding-top: 15px;
  padding-bottom: 15px; 
`}
`;

export const StyledPrice = styled.div`
  display: flex;
  ${pl(2)};
  flex-direction: column;
  font-size: 18px;
  justify-content: space-between;
  ${breakpoint('mobile', 'tablet')`
  ${pl(0)};
`};
`;

export const StyledFinalPrice = styled.div`
  font-size: 20px;
  color: ${theme.colors.logoBlue};
  ${breakpoint('mobile', 'tablet')`
  font-size: 16px;
`};
`;

export const StyledSaveWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  svg {
    ${p(1)};
    width: 20px;
    height: 100%;
  }
  ${breakpoint('mobile', 'tablet')`
 row-gap: 5px;
`};

  ${breakpoint('desktop')`
  row-gap: 10px;
  flex-direction: column;
`}
`;

export const StyledSaveInfoContent = styled.span`
  color: ${colors.saveGreen};
  font-weight: 600;

  ${breakpoint('mobile', 'desktop')`
  font-size: 18px;
`}

  ${breakpoint('desktop')`
   font-size: 20px;
`}
`;

export const StyledAmountContent = styled.div`
  ${breakpoint('mobile', 'tablet')`
  ${pl(1)};
 `}

  ${breakpoint('desktop')`
   display: flex;
   align-items: center;
 `}
`;
export const StyledOldPrice = styled.span`
  font-size: 28px;
  font-weight: 600;
  color: ${theme.colors.red};
  text-decoration: line-through;

  ${breakpoint('mobile', 'tablet')`
  font-size:24px;
`};

  ${breakpoint('tablet', 'desktop')`
  font-size: 26px;
`}
`;
export const StyledPayNow = styled.span`
  font-size: 28px;
  margin-left: 10px;
  color: ${theme.colors.navyGray};
  font-weight: 600;
  ${breakpoint('mobile', 'tablet')`
  font-size:24px;
`};

  ${breakpoint('tablet', 'desktop')`
  font-size: 26px;
`}
`;

export const StyledBookButton = styled.button`
  color: ${theme.colors.white};
  width: 100%;
  font-size: 24px;
  cursor: pointer;
  :hover {
    filter: brightness(1.2);
  }
  transition: filter 0.3s ease;
  background-color: ${theme.colors.whitishGreen};
  border: none;
  border-radius: 8px;
  outline: none;
  font-weight: 600;
  margin: 0 auto;
  padding: 1rem 2rem;
  ${breakpoint('mobile', 'desktop')`
 ${py(3)};
 ${px(3)};
 margin: 1rem auto;
 font-size: 20px;
`};
`;

export const StyledBookText = styled.h3`
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  ${breakpoint('mobile', 'tablet')`
 font-size: 11px;
`};
  ${breakpoint('desktop')`
  padding: 20px;
`}
`;

export const StyledDoctorsCardWrapper = styled.div`
  ${m(2)};
  ${p(3)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ${theme.shadows.mediumStrong}
  border-radius: 8px;
`;

export const StyledCardsLeftWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const StyledCardsRightWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const StyledDoctorsCardTitle = styled.div`
  margin: 0 auto;
  text-align: center;
  ${p(1)};
  svg {
    ${pr(1)};
    width: 25px;
    height: 100%;
  }
  color: ${theme.colors.newThemeDarkBlue};
  font-weight: bold;
  font-size: 25px;
  ${breakpoint('mobile', 'desktop')`
    font-size: 22px;
    svg {
    ${pr(1)};
    width: 22px;
    height: 100%;
  }
  `};
`;

export const StyledDoctorsNameTitle = styled.div`
  color: ${theme.colors.newThemeDarkBlue};
  font-weight: bold;
  font-size: 18px;
  ${p(1)};
`;
export const StyledDoctorsNameSubtitle = styled.div`
  color: ${theme.colors.mediumGray};
  font-weight: bold;
  ${p(1)};
  font-size: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: center;

  svg {
    height: 20px;
    width: 20px;
    ${pr(1)};
  }
`;
export const StyledDoctorsHospitalName = styled.h3`
  color: ${theme.colors.mediumGray};
  font-size: 12px;
  font-weight: 600;
  ${p(1)};
  svg {
    ${pr(1)};
    color: ${theme.colors.mediumGray};
    width: 12px;
  }
`;

export const StyledCardImage = styled.div`
  ${p(3)};
  display: flex;
  flex-direction: row;
  justify-content: center;
  max-width: 100%;
  border: 2px solid transparent;
  img {
    width: 60%;
    min-width: 150px;
    aspect-ratio: 1/1;
    border-radius: 100%;
  }
`;

export const StyledDoctorsHeadings = styled.div`
  color: ${theme.colors.newThemeDarkBlue};
  font-weight: bold;
  font-size: 22px;
  ${p(3)};
  ${breakpoint('mobile', 'desktop')`
    font-size: 18px;
  `}
`;

export const StyledSepratorGray = styled.hr`
  color: ${theme.colors.mediumGray};
  width: 80%;
  ${breakpoint('mobile', 'desktop')`
    width: 100%;
  `}
`;

export const StyledViewProfileButtonWrapper = styled.div`
  a {
    text-decoration: none;
  }
`;
export const StyledViewProfileButton = styled.button`
  ${m(3)};
  cursor: pointer;
  svg {
    ${pl(1)};
    width: 14px;
  }
  border: 2px solid ${theme.colors.logoBlue};
  border-radius: 6px;
  font-weight: 700;
  max-width: max-content;
  transition: all 0.3s;
  :hover {
    background-color: ${theme.colors.logoBlue};
    color: white;
    svg,
    path {
      fill: ${theme.colors.white};
      stroke: ${theme.colors.white};
    }
  }
  ${p(2)};
  color: ${theme.colors.logoBlue};
  background-color: transparent;
  display: flex;
  flex-direction: row;
`;

export const StyledTestimonialWrapper = styled.div`
  display: flex;
`;

export const StyledHospitalCardWrapper = styled.div`
  ${m(2)};
  ${p(3)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ${theme.shadows.mediumStrong}
  border-radius: 8px;
`;

export const StyledHospitalCardTitle = styled.div`
  color: ${theme.colors.navyGray};
  align-self: start;
  font-size: 22px;
  ${pt(4)};
  ${pb(2)};
  ${px(3)};
  svg,
  path {
    ${px(1)};
    color: ${theme.colors.navyGray};
    fill: ${theme.colors.navyGray};
    width: 20px;
  }
  ${breakpoint('mobile', 'desktop')`
      font-size: 20px;
  }
  `};
`;
export const StyledHospitalCardDescription = styled.div`
  color: ${theme.colors.navyGray};
  font-size: 18px;
  ${p(3)};
  line-height: 1.8rem;
`;

export const StyledHeadlines = styled.div`
  font-size: 25px;
  font-weight: bold;
  line-height: 1.8rem;
  ${px(2)};
  ${py(3)};
  ${my(2)};
  ${breakpoint('mobile', 'desktop')`
  font-size: 20px;
  `}
`;

export const StyledFormWrapper = styled.div`
  top: 90px;
  position: sticky;

  ${breakpoint('mobile', 'desktop')`
    display: none;
  `}
`;

export const StyledComponentWrappers = styled.div`
  ${pt(4)}
  ${mt(1)};

  ${breakpoint('mobile', 'desktop')`
  ${pt(3)};
  `}
`;
